import dendaLogo from "../../public/static/images/png/icon-biaya-denda-dan-bunga.png";
import czLogo from "../../public/static/images/png/icon-client-zone.png";
import hcidLogo from "../../public/static/images/png/icon-my-home-credit-app.png";
import complainLogo from "../../public/static/images/png/icon-keluhan.png";

export const DataPanduanKonsumen = [
  {
    name: "My Home Credit App",
    image: hcidLogo,
    slug: "panduan-konsumen/my-home-credit-app",
  },
  {
    name: "Tanda Tangan Elektronik",
    image: czLogo,
    slug: "panduan-konsumen/tanda-tangan-elektronik",
  },
  {
    name: "Biaya, Denda, dan Bunga",
    image: dendaLogo,
    slug: "panduan-konsumen/biaya-denda-dan-bunga",
  },
  {
    name: "Keluhan",
    image: complainLogo,
    slug: "panduan-konsumen/keluhan",
  },
];
